import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { useEffect, } from "react";
import MaterialTable from "material-table";
import MaterialFlavors from "material-table";


const ReturnRecevingList = (props) => {

  useEffect(() => {
    props.setHeading("Receiving Return List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialFlavors
          title="Receiving Return List"
          columns={[
            { title: "Return Date", field: "date", editable: "never" },
            { title: "Reason", field: "reason", editable: "never" },
            { title: "Total Return", field: "totalPrice", editable: "never" },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/receiving/return-receiving-list?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, {
                method: "POST",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          detailPanel={(rowData) => {
            return (
              <MaterialTable
                columns={[
                  { title: "Product Name ", field: "productName", editable: "never", },
                  { title: "Return Quantity", field: "returnQuantity", },
                  { title: "Price", field: "productPrice", editable: "never", },
                ]}
                data={rowData.returnData}
                options={{
                  actionsColumnIndex: -1,
                  toolbar: false,
                  exportButton: true,
                  sorting: true,
                  paging: false,
                  pageSize: 200,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [50, 100, 150, 200],
                  headerStyle: {
                    position: "sticky",
                    top: 0,
                    color: "#00BBBB",
                    fontWeight: "550",
                    onRowAdd: "none",
                  },
                }}
              />
            );
          }}
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingReceiving: state.RecivingReducer.isFetchingReceiving,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnRecevingList);
